(window as unknown as { global: unknown }).global = window;

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((_err) => {}); // console.error(err)
